import {actions} from 'react-fields'

export default class FlexibleFormApi {

    static getForm(formId) {
        let url = `/api/flexible_forms/${formId}`;
        return fetch(actions.getData(url))
            .then(actions.status)
            .then(actions.json)
            .then((data) => {
                return data;
            })
    }

    static submit(token, form, mediaKit, onSuccess, onError) {
        let fields = {};
        form.fields.map((f) => fields[`field_${f.id}`] = f.value);
        let data = {form: {id: form.id, fields: fields},
            request_media_kit: mediaKit, subscription: form.subscription,
            source_url: document.location.href};
        if (token) {
            data[token.key] = token.value;
            data['turnstile_error'] = token.errors;
        }
        const url = '/api/flexible_forms/submit';

        fetch(actions.postRequest(url, data ))
            .then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            }).then( async (response) => {
            onSuccess(response);
        }).catch(error => {
            console.log(error);
            error.json().then(function (value) {
                onError(value);
            });
        });
    }


}